import "~/stylesheets/application.css"
import "@hotwired/turbo-rails"
import "~/controllers"

const root = document.documentElement

const disableFlowTransitions = () => {
  root.classList.remove("flow-transitions-ready")
}

const enableFlowTransitions = () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      root.classList.add("flow-transitions-ready")
    })
  })
}

document.addEventListener("turbo:before-render", disableFlowTransitions)
document.addEventListener("turbo:load", enableFlowTransitions)

enableFlowTransitions()
